<template>
  <v-container fluid v-if="isAuthNb == 3" class="home">
    <p class="calendarP">
    <CalendarWeekComponent 
      :withArrs="false" 
      :leftArrFunction="emptyFunction" 
      :rightArrFunction="emptyFunction"
      :withDaySelect="false" 
      :dayFunction="emptyFunction"
      :weekdatesdatas="weekdatesdatas" />
    </p>
    <v-sheet  class="mx-auto d-flex align-content-center flex-wrap iconSheet ">
      <div class="dataDetails"  v-for="(groupedentries,attributegroup) in todayData">
        {{ attributegroup }}:
        <span  v-for="(attributeentries,attribute) in groupedentries">
            <span v-if="typeof attributeentries[0].value === 'boolean'" v-html="attribute" style="font-weight: normal; margin-right: 10px; padding: 2px; border: 1px solid grey;"></span>
            <span v-if="typeof attributeentries[0].value === 'string'" v-html="attributeentries[0].value" style="font-weight: normal; margin-right: 10px; padding: 2px;"></span>
            <!--<div  v-for="(attributeTimeEntries,counter) in attributeentries">
                <div v-if="attributeTimeEntries.value == true">von: {{ attributeTimeEntries.timeFrom }} bis: {{ attributeTimeEntries.timeTo }}</div>
             
            </div>
            --> 
        </span>
    </div>
    <InfoBox infoBoxType="carouselPlusSep" :PredictedSummary=PredictedSummary />
    </v-sheet>
    <HormonalContraception/>
    <CyclePattern/>
    <PCOS/>
  </v-container>
  <v-container fluid v-else>
    <welcomeView/>
  </v-container>
  
</template>

<script >
  import { AppStates } from "@/models/AppStates";
  import { useObservable } from "@vueuse/rxjs";
  import { liveQuery } from "dexie";
  import WelcomeView from '../views_out/WelcomeView.vue'

  import CalendarWeekComponent from './CalendarParts/CalendarWeekComponent.vue'
  import { ref, onMounted, onUnmounted, isProxy } from 'vue'
  import {getWeekDatesDatas,getWeekDatesDatasMonday} from '../scripts/weekdatesdataloader'
  //import getWeekDatesDatasMonday from '../scripts/weekdatesdataloader'
  import { DataSummaries } from '@/models/DataSummaries'; 
  import { PeriodDay } from '@/models/PeriodDay'; 
  import  InfoBox  from "@/components/InfoBoxes.vue"
  import HormonalContraception from "@/components/Overlay/HormonalContraception.vue"
  import CyclePattern from "@/components/Overlay/CyclePattern.vue"
  import PCOS from "@/components/Overlay/PCOS.vue"

  export default {
    components:{
      WelcomeView,
      CalendarWeekComponent,
      InfoBox,
      HormonalContraception,
      CyclePattern,
      PCOS,
    },
    data: () => ({
      absolute: true,
      opacity: 1,
      overlay: false,
      isAuthNb:0,
      PredictedSummary:Object
    }),
    methods:{
      emptyFunction(){

      },
      async daybefore(){
                let NewShowDate = new Date();
                NewShowDate.setTime((this.showTS - 24*60*60*1000));
                this.ShowDate = NewShowDate;
                this.showTS = NewShowDate.getTime();
                this.weekdatesdatas = getWeekDatesDatas(NewShowDate);
                this.todayData = await DataSummaries.getAllDayValues(this.ShowDate);
            },
            async dayafter(){
                let NewShowDate = new Date();
                NewShowDate.setTime((this.showTS + 24*60*60*1000));
                this.ShowDate = NewShowDate;
                this.showTS = NewShowDate.getTime();
                this.weekdatesdatas = getWeekDatesDatas(NewShowDate);
                this.todayData = await DataSummaries.getAllDayValues(this.ShowDate);
            },
            async daySelect(dayStr){
                let NewShowDate = new Date(dayStr +' 12:00:00');
                this.ShowDate = NewShowDate;
                this.showTS = NewShowDate.getTime();
                this.weekdatesdatas = getWeekDatesDatas(NewShowDate);
                this.todayData = await DataSummaries.getAllDayValues(this.ShowDate);
            }
    },
    mounted(){
        document.addEventListener("dataSyncFinished", e => {
            let selDay = document.getElementsByClassName('showday');
                if(typeof selDay != 'undefined')
                    if(typeof selDay[0] != 'undefined')
                        if(typeof selDay[0].parentElement != 'undefined')
                            if(typeof selDay[0].parentElement.parentElement.id != 'undefined'){
                              // if there will be datafrom backend for tody ToDo: do this without getWeekDatesDatas
                              //this.daySelect(selDay[0].parentElement.parentElement.id)
                            }
                                
        })
    },
    setup() {
      const CurrentDate = new Date();

      const Today = new Date();
      const showTS = ref(CurrentDate.getTime());
      const weekdatesdatas = ref(getWeekDatesDatasMonday(Today));
      const todayData = ref([]);
      const periodData = ref([]);
      const ShowDate = ref(CurrentDate);
      let PredictedSummary =  ref(null)

      onMounted(
        
        async () => {
        //todayData.value = await DataSummaries.getAllDayValues(CurrentDate);
        
        PredictedSummary.value = await AppStates.getAuthNumberLive().then((authnb) => { 
          if(authnb == 3){
            return DataSummaries.getPeriodDays('withDayInfos').then((res) => {
            
            //console.log(res)
            for(var i = 0; i < res.alldays.length; i++){
              let ele = document.getElementById('wp'+res.alldays[i]);
              if(ele != null){
                // class to period
              }
            }
            for(var i = 0; i < res.firstDays.length; i++){
              let ele = document.getElementById('wp'+res.firstDays[i]);
              if(ele != null){
                // class to first day period
              }
            }
            for(var i = 0; i < res.lastDays.length; i++){
              let ele = document.getElementById('wp'+res.lastDays[i]);
              if(ele != null){
                // class to last day period
              }
            }
            for(var i = 0; i < res.preOvulationDays.length; i++){
              let ele = document.getElementById('wp'+res.preOvulationDays[i]);
              if(ele != null){
                // class to preOvulationDays 
                ele.classList.add('preOvulationDays')
              }
            }
            for(var i = 0; i < res.ovulationDays.length; i++){
              let ele = document.getElementById('wp'+res.ovulationDays[i]);
              if(ele != null){
                // class to ovulationDays
                ele.classList.add('ovulationDays')
              }
            }
            for(var i = 0; i < res.postOvulationDays.length; i++){
              let ele = document.getElementById('wp'+res.postOvulationDays[i]);
              if(ele != null){
                // class to postOvulationDays
                ele.classList.add('postOvulationDays')
              }
            }
            return res;
        
          })
        }
      })
        
      });


      return {
        isAuthNb: useObservable(
          liveQuery(async () => {
            return await AppStates.getAuthNumberLive();
          })
        ),
        weekdatesdatas,
        todayData, 
        ShowDate,
        showTS,
        PredictedSummary,
      };
    }
  }
</script>

<style>
.iconSheet{
    max-width: 800px;
    
    border-radius: 20px;
    margin-top: 15px;
    padding-top:20px;
    justify-content: center;
}
.iconSheet div{
  width:300px;
}
.calendarP{
  margin-top: 20px;
}
.dataDetails{
  margin:20px; 
  font-weight: bold;
  width: 100%;
}
.home .daynb{
    font-size: small;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    display: table-cell;
}
.home .datedataweek .v-col,
.home .datedataweek p{
  width: 40px;
    height: 40px;
    display: contents;
}
.singlePeriodDay{
  background-size: 30px;
  background-position: 5px;
  background-image: url('~@/assets/periodSingleDay.png');
}
.firstPeriodDay{
  color: #fff;
  background-size: 60px 30px;
  background-position: 5px;
  background-image: url('~@/assets/periodFirstDay.png');
}
.lastPeriodDay{
  color: #fff;
  background-size: 60px 30px;
  background-position: -25px;
  background-image: url('~@/assets/periodLastDay.png');
}
.predictedPeriodDay{
  background-size: 30px;
  background-position: 5px;
  background-image: url('~@/assets/periodPrediction.png');
}
.betweenPeriodDay{
  background-size: 60px 30px;
  background-position: 0px;
  background-image: url('~@/assets/periodBetweenDay.png');
}

.postOvulationDays{
  background-size: 30px;
  background-position: 5px;
  background-image: url('~@/assets/ovulationPrePostPrediction.png');
}
.ovulationDays{
  background-size: 30px;
  background-position: 5px;
  background-image: url('~@/assets/ovulationPrediction.png');
}
.preOvulationDays{
  background-size: 30px;
  background-position: 5px;
  background-image: url('~@/assets/ovulationPrePostPrediction.png');
}
</style>